exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".die-to-fly-logo {\n  color: black;\n  font-size: 52px;\n  letter-spacing: -6px;\n  font-family: 'Archivo Black', sans-serif;\n}\n.die-to-fly-logo__die {\n  color: red;\n  font-weight: bold;\n}\n.die-to-fly-logo__to {\n  color: black;\n}\n.die-to-fly-logo__fly {\n  color: red;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.die-to-fly-logo__dot-com {\n  font-size: 25px;\n  color: black;\n  letter-spacing: -2px;\n}\n", ""]);

// exports
